import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _ForgotPasswordOtpRequest = async (searchData = false) => {
  let url = ServiceUrl.LOGIN_V2.FORGOT_PASS_GET_OTP;
  return callApi(url, "post", searchData && searchData);
};

export const _UpdateNewPassword = async (searchData = false) => {
  let url = ServiceUrl.LOGIN_V2.UPDATE_NEW_PASSWORD;
  return callApi(url, "post", searchData && searchData);
};
